import { api } from './api'
import { nativePlatform, openOutside } from './platform'

export type LoginResult = 'ok' | 'linked' | 'taken' | 'expired' | 'cancelled'

/** Вход (или привязка) через бота: создаём заявку, открываем Telegram,
 *  ждём, пока человек подтвердит вход кнопкой в чате.
 *  Возвращает токен при входе; при привязке токена нет — приложение уже вошло. */
export function telegramLogin(): {
  result: Promise<{ status: LoginResult; token: string | null }>
  cancel: () => void
  reopen: () => void
} {
  let cancelled = false
  let link: { url: string; deep: string } | null = null

  const result = (async () => {
    const start = await api.authTelegramStart()
    link = { url: start.url, deep: start.deep }
    await openOutside(start.deep, start.url)
    const deadline = Date.now() + start.expires_in * 1000
    while (!cancelled && Date.now() < deadline) {
      await new Promise((r) => setTimeout(r, 2000))
      if (cancelled) break
      try {
        const state = await api.authTelegramPoll(start.nonce, nativePlatform)
        if (state.status !== 'pending') return { status: state.status as LoginResult, token: state.token }
      } catch {
        /* сеть моргнула, пока приложение было в фоне — пробуем дальше */
      }
    }
    return { status: (cancelled ? 'cancelled' : 'expired') as LoginResult, token: null }
  })()

  return {
    result,
    cancel: () => {
      cancelled = true
    },
    reopen: () => {
      if (link) void openOutside(link.deep, link.url)
    },
  }
}
